<div class="card-body mt-0 pt-4">

    <p-table 
    [value]="petService.pet_treatment_plan" 
    [paginator]="true"
    [rows]="10"   
    class="table table-sm table-striped" >
 
        <ng-template pTemplate="header">
            <tr> 
                <th style="width: 15%;">Req. Date</th>  
                <th>Procedure Description</th>
                <th style="width: 10%;">Requested by</th>
                <th style="width: 10%;">Unit</th>
                <th style="width: 10%;">Alt Days</th>
                <th style="width: 10%;">Start</th>
                <th style="width: 10%;"># Left</th>
                <th style="width: 5%;">Notes</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-plan>
            <tr>
                <td>{{ plan.req_date | date:'MM/dd/yyyy hh:mm a' }}</td>  
                <td>{{ plan.code_name }}({{ plan.procedure_desc }})</td>
                <td>{{ plan.req_by }}</td>
                <td>{{ plan.unit }}</td>
                <td>{{ plan.alt_days }}</td>
                <td>{{ plan.start_date | date:'MM/dd/yyyy' }}</td>
                <td>{{ plan.remain_times }}</td>
                <td>
                    <button type="button" 
                            class="btn btn-icon btn-light btn-hover-primary btn-xs" 
                            title="{{ plan.remarks }}"
                            (click)="noteBtnClick(plan)"> 
                        <i class="las la-file-invoice"></i>
                    </button>
                </td>
            </tr>
        </ng-template>

    </p-table>

             
</div>
<div class="card-footer text-right py-4"> 
    <!-- <button type="submit" class="btn btn-primary btn-sm">
        <i class="las la-print"></i> Print
    </button> -->
</div>

<div class="modal fade" id="NoteModal" tabindex="-1" aria-labelledby="addNoteModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addNoteModalLabel">Treatment Note</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <i aria-hidden="true" class="ki ki-close"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="mb-3"> 
                    <label for="note" class="form-label">Note</label>
                    <textarea class="form-control" id="note" [(ngModel)]="noteText" rows="5"></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="saveNote()">Save</button> 
            </div>
        </div>
    </div>
</div>